<script>
  import { fade } from "svelte/transition"
  import OptionRow from "./CartSidebar/OptionRow.svelte"

  export let taxon
  export let selectedDuration
  export let selectedRelatedProducts
  export let selectedAdditionalPendants

  export let selectedHelpButton
  export let selectedSecondHelpButton
  export let selectedFallDetection
  export let selectedProtectionPlan
  export let selectedDailyCheckIn
  export let selectedCaregiverApp
  export let selectedMedicationReminders
  export let selectedLocationService
  export let selectedActivityAssurance
  export let selectedWristbandType

  let sidebarOpen

  if (window.matchMedia("(max-width: 1900px)").matches) {
    sidebarOpen = false
  } else {
    sidebarOpen = true
  }
</script>

<div
  class="top-0 fixed w-80 -right-80 h-full py-4 px-6 z-20 mr-0 text-white bg-emerald-primary flex items-center cart-sidebar transition-all"
  {sidebarOpen}
>
  <button
    title={sidebarOpen ? "Hide Sidebar" : "Show Sidebar"}
    class="absolute -left-10 w-12 bg-emerald-primary rounded-lg text-white hover:scale-110 sidebar-toggle transition-transform flex flex-col items-center justify-center p-4"
    on:click={() => (sidebarOpen = !sidebarOpen)}
  >
    <div class="inline-block">
      <i class="fa-solid fa-caret-left transition-transform" />
    </div>
    <span class="selections">Selections</span>
  </button>
  <div class="max-h-full overflow-auto">
    <h3 class="text-3xl font-bold mb-2 leading-10">Selections</h3>
    <p class="text-sm mb-1">{@html taxon.name}</p>
    <table>
      <tr>
        <th>Duration</th>
        <td class="capitalize">
          {selectedDuration}
        </td>
      </tr>
      <OptionRow option={selectedHelpButton} />
      <OptionRow option={selectedSecondHelpButton} />
      <OptionRow option={selectedWristbandType} />
      <OptionRow option={selectedFallDetection} />
      <OptionRow option={selectedProtectionPlan} />
      <OptionRow option={selectedDailyCheckIn} />
      <OptionRow option={selectedCaregiverApp} />
      <OptionRow option={selectedMedicationReminders} />
      <OptionRow option={selectedLocationService} />
      <OptionRow option={selectedActivityAssurance} />
      <OptionRow option={selectedActivityAssurance} />
    </table>

    {#each [selectedAdditionalPendants, selectedRelatedProducts] as items, i}
      {#if items.length > 0}
        <h4 class="text-xl font-bold my-2 leading-8" transition:fade>
          {#if i === 0} Additional Pendants {/if}
          {#if i === 1} Add Ons {/if}
        </h4>
        <table>
          <tr transition:fade>
            <th>Product</th>
            <th>Qty</th>
            <th>Price</th>
          </tr>
          {#each items as relatedProduct}
            <tr transition:fade>
              <td>{@html relatedProduct.name}</td>
              <td>{relatedProduct.qty}</td>
              <td>${(relatedProduct.price * relatedProduct.qty).toFixed(2)}</td>
            </tr>
          {/each}
        </table>
      {/if}
    {/each}
  </div>
</div>
